import { Fragment } from "react";
import ReactDOM from "react-dom";

import styles from "./Modal.module.css";

const Backdrop = (props) => {
  return <div className={styles.backdrop} onClick={props.onClose} />;
};

const ModalOverlay = (props) => {
  return (
    <div className={`${props.quoteInfo ? styles.resize : ''} ${styles.modal}`}>
      <div className={styles.content}>{props.children}</div>
    </div>
  );
};

const overlaysPortalElement = document.getElementById("overlays");

const Modal = (props) => {
  return (
    <div>
      {ReactDOM.createPortal(
        <Backdrop onClose={props.onClose} />,
        overlaysPortalElement
      )}
      {ReactDOM.createPortal(
        <ModalOverlay quoteInfo={props.quoteInfo}>{props.children}</ModalOverlay>,
        overlaysPortalElement
      )}
    </div>
  );
};

export default Modal;
